@import (reference) '../../../../../../constants/spacing.module.less';

.returnsTabSection {
  padding: @space-24;
  margin-bottom: @space-24;
}
